import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import styles from './text-with-info.module.scss';

interface TextWithInfoProps {
  className?: string;
  text: string;
  subText: string;

  onClick(): void;
}

export function TextWithInfo({className = '', ...props}: TextWithInfoProps): ReactElement<any> | null {
  return (
    <div
      onClick={(): void => {
        props.onClick();
      }}
      className={`flex-v-row radius-8 ${className} ${styles.container}`}
    >
      <Text className={styles.text} val={props.text} size={TextSize.XSMALL} bold />
      <Text val={props.subText} size={TextSize.XXSMALL} className="content-sub-text" />
    </div>
  );
}
